import { FIELD_TECHS_CRUD_ACTION_CREATORS } from '../actions/field_techs_actions';
import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import FetchUtils, { parseJSON } from './fetch_utils';
import { getBackendUri } from '../utils/EnvConfigUtils';
import { logoutSuccess } from '../actions/session_actions';
const fetchUtils = new FetchUtils();
const baseUrl = getBackendUri();

export const fieldTechsRestCrudThunksForBuyer = new RestCrudThunks(
	'field_techs',
	'field_tech',
	'fieldTech',
	'fieldTechs',
	FIELD_TECHS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'field_tech/'
);

export const fieldTechsRestCrudThunksForSupplier = new RestCrudThunks(
	'field_techs',
	'field_tech',
	'fieldTech',
	'fieldTechs',
	FIELD_TECHS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'field_tech/'
);

export const allowFieldTechToManageStockLocations = (roleType) => (entity) => {
	const apiURL = `/api/v1/${roleType}/field_tech/field_techs/allow_field_tech_to_manage_stock_location/${entity.email}`;
	const baseUrl = getBackendUri();
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateStart(entity));
			fetchUtils
				.put(baseUrl + apiURL, {
					headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
					data: entity,
				})
				.then(parseJSON)
				.then(({ json, status, ok }) => {
					const d = json;
					if (d.status === 'error') {
						dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject('An error occurred in updating field tech.' || d.message);
					} else {
						dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
						resolve(d.data);
					}
				})
				.catch((d) => {
					dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
					reject('An error occurred in updating field tech.' || d.message);
				});
		});
	};
};

export const allowFieldTechToManageStockLocationsForSupplier = allowFieldTechToManageStockLocations(
	ROLE_TYPES.SUPPLIER
);

// Partial update of a single field tech. The backend PATCH only reads the fields present in the
// payload (problemTypeIds, inventorySupervisorEmails) and preserves everything else, so each edit
// card can send just the attribute it owns without clobbering the others.
export const patchFieldTech =
	(roleType) =>
	(payload: { email: string; problemTypeIds?: number[]; inventorySupervisorEmails?: string[] }) => {
		const apiURL = `/api/v1/${roleType}/field_tech/field_techs`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateStart(payload));
				fetchUtils
					.patch(baseUrl + apiURL, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: payload,
					})
					.then(parseJSON)
					.then(({ json }) => {
						const d = json;
						if (d.status === 'error') {
							dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateError(d.message, payload));
							reject(d.message || 'An error occurred in updating field tech.');
						} else {
							dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateError(d.message, payload));
						reject(d.message || 'An error occurred in updating field tech.');
					});
			});
		};
	};

export const patchFieldTechForSupplier = patchFieldTech(ROLE_TYPES.SUPPLIER);

// Updates just the field tech's given/family name. The standard PUT update does not persist name
// changes, so name edits go through this dedicated endpoint alongside the regular update. The
// backend keys off `userId` (the target field tech's email) and only writes the name columns
// present in the payload, leaving roles/access and every other attribute untouched.
export const updateFieldTechName =
	(roleType) => (payload: { userId: string; nameGiven?: string; nameFamily?: string }) => {
		const apiURL = `/api/v1/${roleType}/updateFieldTechName`;
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateStart(payload));
				fetchUtils
					.patch(baseUrl + apiURL, {
						headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
						data: payload,
					})
					.then(parseJSON)
					.then(({ json }) => {
						const d = json;
						if (d.status === 'error') {
							dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateError(d.message, payload));
							reject(d.message || 'An error occurred in updating field tech name.');
						} else {
							dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(FIELD_TECHS_CRUD_ACTION_CREATORS.updateError(d.message, payload));
						reject(d.message || 'An error occurred in updating field tech name.');
					});
			});
		};
	};

export const updateFieldTechNameForSupplier = updateFieldTechName(ROLE_TYPES.SUPPLIER);
